import { render, staticRenderFns } from "./drawer_JiYangPetCage.vue?vue&type=template&id=aba35e52&scoped=true&"
import script from "./drawer_JiYangPetCage.vue?vue&type=script&lang=js&"
export * from "./drawer_JiYangPetCage.vue?vue&type=script&lang=js&"
import style0 from "./drawer_JiYangPetCage.vue?vue&type=style&index=0&id=aba35e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba35e52",
  null
  
)

export default component.exports